export default "__VITE_ASSET__09babc19__"